import { Link, NavLink } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { Logo } from "@/components/layout/Logo";
import { useAuth } from "@/context/AuthContext";
import { startLogin } from "@/lib/api";

export const PublicNav = () => {
  const { user } = useAuth();
  const link = ({ isActive }) =>
    `text-sm font-medium ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`;
  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-black/60 backdrop-blur-xl" data-testid="public-nav">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <div className="flex items-center gap-10">
          <Logo />
          <nav className="hidden items-center gap-7 md:flex">
            <NavLink to="/marketplace" className={link} data-testid="nav-marketplace-link">Marketplace</NavLink>
            <NavLink to="/models" className={link} data-testid="nav-local-models-link">Modelos locales</NavLink>
            <NavLink to="/software" className={link} data-testid="nav-software-link">Software</NavLink>
            <a href="/#como-funciona" className="text-sm font-medium text-zinc-400 hover:text-white" data-testid="nav-how-link">Cómo funciona</a>
          </nav>
        </div>
        {user ? (
          <Link to="/dashboard" className="btn-primary !py-2" data-testid="nav-dashboard-button">
            Ir al panel <ArrowRight size={16} weight="bold" />
          </Link>
        ) : (
          <div className="flex items-center gap-3">
            <button onClick={() => startLogin("/dashboard")} className="hidden text-sm font-medium text-zinc-300 hover:text-white sm:block" data-testid="nav-login-button">
              Iniciar sesión
            </button>
            <button onClick={() => startLogin("/agents/new")} className="btn-primary !py-2" data-testid="nav-start-button">
              Crear agente <ArrowRight size={16} weight="bold" />
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
